import { useMutation, useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import axios from 'axios';
import { useAppDispatch } from 'src/services/redux/app/Store';
import { setMerchantTemplateIdReducer, setTemplateNumberReducer, setTemplateReducer } from 'src/services/redux/slices/template/template-slice';
import { useSelector } from 'react-redux';
import { RootState } from 'src/services';

export interface ShowcaseTemplateType {
    id: number;
    name: string;
    isActive:boolean;
    thumbnail:string;
    selected:boolean
}


const REACT_APP_API_CMS_URL = `${process.env.REACT_APP_API_CMS_URL}`;


export const useGetActiveTemplate = (onError?: any) => {
  const getActiveTemplate = async () => {
    const activeTemplate = (await axios.get<any[]>(`${REACT_APP_API_CMS_URL}/mc/schemas`)).data;
    return { activeTemplate };
  };

  return useQuery(['showcase-active-list'], getActiveTemplate, {
    refetchOnWindowFocus: false,
    onError: (err: any) => {
      toast.error('Bir sorun oluştu.', { autoClose: 2000 });
    },
  });
};

export const useGetShowcaseTemplate = (onError?: any) => {
    const getShowcaseTemplate = async () => {
      const templateList = (await axios.get<ShowcaseTemplateType[]>(`${REACT_APP_API_CMS_URL}/mc/template`)).data;
      return { templateList };
    };
  
    return useQuery(['showcase-template-list'], getShowcaseTemplate, {
      refetchOnWindowFocus: false,
      onError: (err: any) => {
        toast.error('Bir sorun oluştu.', { autoClose: 2000 });
      },
    });
};

export const useGetVendorStatus = (onError?: any) => {
    const getVendorStatus = async () => {
      const status = (await axios.get<any[]>(`${REACT_APP_API_CMS_URL}/mc/vendor`)).data;
      return { status };
    };
  
    return useQuery(['showcase-vendor-status'], getVendorStatus, {
      refetchOnWindowFocus: false,
      onError: (err: any) => {
        toast.error('Bir sorun oluştu.', { autoClose: 2000 });
      },
    });
};


export const useChangeVendorStatus= (onError?: any) => {

  const chanageStatus = async ({ payload, vendor }: { payload: any; vendor?: string }) => {
    const status:any = (await axios.post<any[]>(`${REACT_APP_API_CMS_URL}/mc/vendor/${vendor ? `${vendor}` : ''}`, payload)).data;
    return { status };
  };

  return useMutation(chanageStatus, {
    onError: (err: any) => {
      toast.error('Bir sorun oluştu.', { autoClose: 2000 });
      if (onError) onError(err);
    },
  });
};



export const useActionTemplate= (onError?: any) => {
  const actionTemplate = async ({ payload, schema }: { payload: any; schema: string }) => {
    const template = (await axios.post<any[]>(`${REACT_APP_API_CMS_URL}/mc/update-state/${schema}`, payload));
    return { template };
  };

  return useMutation(actionTemplate, {
    onError: (err: any) => {
      toast.error('Bir sorun oluştu.', { autoClose: 2000 });
      if (onError) onError(err);
    },
  });
};

export const useCopyTemplate= (onError?: any) => {
  const dispatch = useAppDispatch();
  const copyTemplate = async ({ schema }: { schema: string }) => {
    const template:any = (await axios.get<any[]>(`${REACT_APP_API_CMS_URL}/mc/copy-schema/${schema}`));
    if(template.status === 200) {
      const schemaId = template.data.banners[0].merchantLanding.id || template.data.widgets[0].merchantLanding.id
      const templateId = template.data.banners[0].merchantLanding.template.id || template.data.widgets[0].merchantLanding.template.id
        dispatch(setTemplateNumberReducer(templateId));
        dispatch(setMerchantTemplateIdReducer(schemaId));
    }
  };

  return useMutation(copyTemplate, {
    onError: (err: any) => {
      toast.error('Bir sorun oluştu.', { autoClose: 2000 });
      if (onError) onError(err);
    },
  });
};




export const useGetTemplate = (templateId?: number, onError?: any) => {
  const dispatch = useAppDispatch();
  const getTemplate = async () => {
    const template = (await axios.get<any[]>(`${REACT_APP_API_CMS_URL}/mc/template/${templateId}`)).data;
    dispatch(setTemplateNumberReducer(templateId))
    dispatch(setTemplateReducer(template));
    return { template };
  };

  return useQuery(['showcase-template-detail', templateId], getTemplate, {
    enabled: Boolean(templateId),
    refetchOnWindowFocus: false,
    onError: (err: any) => {
      toast.error('Bir sorun oluştu.', { autoClose: 2000 });
    },
  });
};

export const useGetSelectedTemplate= (onError?: any) => {
  const selectedTemplate = async ({ schema }: { schema: string }) => {
    const template = (await axios.get<any[]>(`${REACT_APP_API_CMS_URL}/mc/schema/${schema}`));
    return { template };
  };

  return useMutation(selectedTemplate, {
    onError: (err: any) => {
      toast.error('Bir sorun oluştu.', { autoClose: 2000 });
      if (onError) onError(err);
    },
  });
};


export const useCreateWidget = (onError?: any) => {
  const merhcantTemplateId = useSelector<RootState, number>((state) => state.template.merchantTemplateId);
  const dispatch = useAppDispatch();
  const createWidget = async ({ payload, schema }: { payload: any; schema?: string }) => {
    const widgetData:any = (await axios.post<any[]>(`${REACT_APP_API_CMS_URL}/mc/widget/new${schema ? `/${schema}` : ''}`, payload)).data;
    if(merhcantTemplateId === 0) {
      dispatch(setMerchantTemplateIdReducer(widgetData.widgets[0].merchantLanding.id))
    }
    return { widgetData };
  };

  return useMutation(createWidget, {
    onError: (err: any) => {
      toast.error('Bir sorun oluştu.', { autoClose: 2000 });
      if (onError) onError(err);
    },
  });
};

export const useCreateBanner= (onError?: any) => {
  const merhcantTemplateId = useSelector<RootState, number>((state) => state.template.merchantTemplateId);
  const dispatch = useAppDispatch();
  const createBanner = async ({ payload, schema }: { payload: any; schema?: string }) => {
    const bannerData:any = (await axios.post<any[]>(`${REACT_APP_API_CMS_URL}/mc/banner/new${schema ? `/${schema}` : ''}`, payload)).data;
    if(merhcantTemplateId <= 0 ) {
      dispatch(setMerchantTemplateIdReducer(bannerData.banners[0].merchantLanding.id))
    }
    return { bannerData };
  };

  return useMutation(createBanner, {
    onError: (err: any) => {
      toast.error('Bir sorun oluştu.', { autoClose: 2000 });
      if (onError) onError(err);
    },
  });
};